import React, { FC } from 'react'
import { SETTINGS_TIME_FORMAT } from 'apps/fleet-planner/types'
import { Select, ISelectProps } from 'transfix-ui'

interface ITimeFormatInputOption {
  /**
   * The friendly name of the option to display to the user.
   */
  label: string

  /**
   * The value of the option, which will be used sent to the parent component.
   */
  value: SETTINGS_TIME_FORMAT
}

export const TIME_FORMAT_OPTIONS: ITimeFormatInputOption[] = [
  {
    label: '1:00pm (Standard Time)',
    value: SETTINGS_TIME_FORMAT.STANDARD,
  },
  {
    label: '13:00 (Military Time)',
    value: SETTINGS_TIME_FORMAT.MILITARY,
  },
]

interface ITimeFormatInputProps {
  /**
   * The parent-controlled time format.
   */
  value: SETTINGS_TIME_FORMAT

  /**
   * The callback function to be called when the time format is changed.
   */
  onChange: (timeformat: SETTINGS_TIME_FORMAT) => void
}

/**
 * A select input for the user to choose the time format.
 */
export const TimeFormatInput: FC<ITimeFormatInputProps> = React.forwardRef(
  ({ onChange, value }, ref) => {
    const changeHandler: ISelectProps['onChange'] = event => {
      onChange(event.target.value as SETTINGS_TIME_FORMAT)
    }

    return (
      <Select
        inputRef={ref}
        dataTest='select-time-format'
        label='Time Format'
        options={TIME_FORMAT_OPTIONS}
        value={value}
        onChange={changeHandler}
        large
      />
    )
  }
)
